// function stickyAtchandler(){var n,t;769<=window.innerWidth||(n={atcWrapper:document.querySelector("[is-atc-handler]"),atcDate:document.querySelector("[is-atc-handler] [is-atc-date]"),atcWrapperButton:document.querySelector("[is-atc-handler] .js-add-to-cart"),stickyATC:document.querySelector("[is-sticky-btn]"),stickyATCInput:document.querySelector("[is-sticky-btn] [name='quantity']"),stickyPlus:document.querySelector("[is-sticky-btn] .js-sticky-plus"),stickyMinus:document.querySelector("[is-sticky-btn] .js-sticky-minus"),stickyButton:document.querySelector("[is-sticky-btn] [is-sticky-atc]")},console.log("sticky refs",n),t=n.atcDate.cloneNode(!0),n.stickyATC.insertAdjacentElement("afterbegin",t),n.stickyButton.addEventListener("click",function(t){n.atcWrapperButton.click();var e={items:[]},c=document.querySelector(".product-single__atc-handlers .js-qty input").value;document.querySelectorAll(".product-single__add-one").forEach(function(t){var t=t.querySelector('input[type="checkbox"]:checked');t&&(t=t.getAttribute("data-id"),e.items.push({id:parseInt(t),quantity:c}))}),console.log(e),setTimeout(function(){fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(e)}).then(function(t){return t.json()}).catch(function(t){console.error("Error:",t)})},500)}),n.stickyPlus.addEventListener("click",function(t){var e=document.querySelector("[is-atc-handler] .js-qty__adjust--plus");n.stickyATCInput.value=+n.stickyATCInput.value+1,e.click()}),n.stickyMinus.addEventListener("click",function(t){var e;+n.stickyATCInput.value-1<+n.stickyATCInput.min||(e=document.querySelector("[is-atc-handler] .js-qty__adjust--minus"),n.stickyATCInput.value=+n.stickyATCInput.value-1,e.click())}),new IntersectionObserver(function(t,e){t.forEach(function(t){t.isIntersecting?n.stickyATC.classList.add("hide-wrap"):n.stickyATC.classList.remove("hide-wrap")})},{root:null,rootMargin:"0px",threshold:.33}).observe(n.atcWrapper))}document.addEventListener("DOMContentLoaded",stickyAtchandler);

document.addEventListener("DOMContentLoaded", stickyAtchandler);

function stickyAtchandler() {
  if (window.innerWidth >= 769) return;

  const refs = {
    atcWrapper: document.querySelector("[is-atc-handler]"),
    atcDate: document.querySelector("[is-atc-handler] [is-atc-date]"),
    atcWrapperButton: document.querySelector(
      "[is-atc-handler] .js-add-to-cart"
    ),

    stickyATC: document.querySelector("[is-sticky-btn]"),
    stickyATCInput: document.querySelector("[is-sticky-btn] [name='quantity']"),
    stickyPlus: document.querySelector("[is-sticky-btn] .js-sticky-plus"),
    stickyMinus: document.querySelector("[is-sticky-btn] .js-sticky-minus"),
    stickyButton: document.querySelector("[is-sticky-btn] [is-sticky-atc]"),
  };

  console.log("sticky refs", refs);

  const copyDateElems = refs.atcDate.cloneNode(true);
  // refs.stickyATC.insertAdjacentElement("afterbegin", copyDateElems);

  refs.stickyButton.addEventListener("click", (event) => {
    refs.atcWrapperButton.click();
    $("[is-sticky-atc]").find(".desk_btn_content").hide();
    $("[is-sticky-atc]").find(".desk_btn_loader").show();
  });

  refs.stickyPlus.addEventListener("click", (event) => {
    const primaryPlus = document.querySelector(
      "[is-atc-handler] .js-qty__adjust--plus"
    );

    refs.stickyATCInput.value = +refs.stickyATCInput.value + 1;
    primaryPlus.click();
  });
  refs.stickyMinus.addEventListener("click", (event) => {
    if (+refs.stickyATCInput.value - 1 < +refs.stickyATCInput.min) return;

    const primaryMinus = document.querySelector(
      "[is-atc-handler] .js-qty__adjust--minus"
    );

    refs.stickyATCInput.value = +refs.stickyATCInput.value - 1;
    primaryMinus.click();
  });

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.33,
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        refs.stickyATC.classList.add("hide-wrap");
        $('#tidio-chat').addClass('positionedBottom');
      } else {
        refs.stickyATC.classList.remove("hide-wrap");
        $('#tidio-chat').removeClass('positionedBottom');
      }
    });
  };

  const btnObserver = new IntersectionObserver(
    observerCallback,
    observerOptions
  );

  btnObserver.observe(refs.atcWrapper);
}

document.addEventListener("DOMContentLoaded", handleStickySoldOut);

function handleStickySoldOut() {
  if (window.innerWidth >= 769) return;

  const els = {
    productOutSection: document.querySelector("#productOut"),
    stickySoldOutBar: document.querySelector("#stickySoldOut"),
  };

  if (!els.productOutSection || !els.stickySoldOutBar) {
    console.warn("Sticky Sold Out: required elements not found.");
    return;
  }

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.33,
  };

  const onProductOutVisibilityChange = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        els.stickySoldOutBar.classList.add("hide-wrap");
        $('#tidio-chat').addClass('positionedBottom');
      } else {
        els.stickySoldOutBar.classList.remove("hide-wrap");
        $('#tidio-chat').removeClass('positionedBottom');
      }
    });
  };

  const observer = new IntersectionObserver(
    onProductOutVisibilityChange,
    observerOptions
  );

  observer.observe(els.productOutSection);
}
